import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-333" data-mp="232nfsn0fptzi">
      <p className="bg-gold px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-ink sm:text-xs md:text-sm" data-id="element-334" data-mp="1y3akrezetglu">
        🇦🇷 Sistema N°1 para Profesores de Gimnasia Rítmica en Argentina
      </p>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-medium text-zinc-300 md:flex" data-id="element-335" data-mp="2qrg5w2udl7m7">
        <span className="flex items-center gap-1.5" data-id="element-336" data-mp="2lu6ggn6zkvyd">
          <ZapIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-337" data-mp="2h1wmmw2r3bqt" /> Acceso en 5 minutos
        </span>
        <span aria-hidden="true" className="text-zinc-700" data-id="element-338" data-mp="2c2k0kdjpe8pa">
          ·
        </span>
        <span className="flex items-center gap-1.5" data-id="element-339" data-mp="39j8yhw5j8qte">
          <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-340" data-mp="39l289kbfzr5m" /> Pago seguro
        </span>
        <span aria-hidden="true" className="text-zinc-700" data-id="element-341" data-mp="34q63djl3x9b3">
          ·
        </span>
        <span className="flex items-center gap-1.5" data-id="element-342" data-mp="2612h84oryz2">
          <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-343" data-mp="672tj1og94py" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}